$(document).ready(function () {

    const circleTypes = new Map();
    const DEBUG_DECK_ACTIONS = true;
    const TOUCH_DECK_DRAG_DELAY_MS = 110;
    let isDeckDragActive = false;
    let suppressDeckCardClickUntil = 0;

    // Simple JS i18n helper
    window.t = function (key, params = {}) {
        let s = (window.I18N && window.I18N[key]) || key;
        for (const k in params) {
            if (Object.prototype.hasOwnProperty.call(params, k)) {
                const re = new RegExp('\\{' + k + '\\}', 'g');
                s = s.replace(re, params[k]);
            }
        }
        return s;
    };

    // Tooltip
    let $tooltip = $('<div class="global-tooltip"></div>').appendTo('body');
    let tooltipTimeout = null;
    function getHeaderMetrics() {
        const $header = $('header');
        const height = $header.length ? ($header.outerHeight(true) || 0) : 0;
        if (!$header.length || !$header.is(':visible')) {
            return { height, offset: 0 };
        }
        const rect = $header.get(0).getBoundingClientRect();
        const isOnScreen = rect.bottom > 0;
        return {
            height,
            offset: isOnScreen ? height : 0
        };
    }
    const syncHeaderHeightVar = () => {
        const { height, offset } = getHeaderMetrics();
        const onboardingHeight = $('.onboarding-journey').outerHeight(true) || 0;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
        document.documentElement.style.setProperty('--header-offset', `${offset}px`);
        document.documentElement.style.setProperty('--onboarding-journey-height', `${onboardingHeight}px`);
    };
    let headerSyncFrame = null;
    const scheduleHeaderHeightSync = () => {
        if (headerSyncFrame !== null) {
            return;
        }
        headerSyncFrame = window.requestAnimationFrame(() => {
            headerSyncFrame = null;
            syncHeaderHeightVar();
        });
    };

    function normPos(e) {
        const oe = e.originalEvent || e;
        if (oe.touches && oe.touches[0]) {
            const t = oe.touches[0];
            return { cx: t.clientX, cy: t.clientY, px: t.pageX, py: t.pageY };
        }
        if (oe.changedTouches && oe.changedTouches[0]) {
            const t = oe.changedTouches[0];
            return { cx: t.clientX, cy: t.clientY, px: t.pageX, py: t.pageY };
        }
        return { cx: e.clientX, cy: e.clientY, px: e.pageX, py: e.pageY };
    }

    function showTooltip(event, $element, contentCallback) {
        if (document.body.classList.contains('deck-drag-scroll-lock')) {
            return;
        }

        const content = contentCallback($element);
        if (!content) return;

        // Préparer la mesure
        $tooltip.html(content).css({ display: 'block', visibility: 'hidden', opacity: 0 });

        let { cx, cy } = normPos(event);
        if (!Number.isFinite(cx) || !Number.isFinite(cy)) {
            const rect = $element.get(0)?.getBoundingClientRect();
            if (!rect) return;
            cx = rect.left + rect.width / 2;
            cy = rect.top;
        }
        const tW = $tooltip.outerWidth();
        const tH = $tooltip.outerHeight();
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const margin = 8;

        // Centre X clampé (on place 'left' sur le centre visuel, grâce au translateX(-50%))
        const centerX = Math.min(Math.max(cx, margin + tW / 2), vw - margin - tW / 2);

        // Au-dessus par défaut, sinon dessous si pas la place
        let top = cy - tH - 12;
        if (top < margin) top = Math.min(cy + 16, vh - margin - tH);

        $tooltip.css({
            left: centerX + 'px',
            top: top + 'px',
            visibility: 'visible',
            opacity: 1
        });

        clearTimeout(tooltipTimeout);
        tooltipTimeout = setTimeout(hideTooltip, 3000);
    }


    function normPos(e) {
        const oe = e.originalEvent || e;
        if (oe.touches && oe.touches[0]) {
            const t = oe.touches[0];
            return { cx: t.clientX, cy: t.clientY };
        }
        if (oe.changedTouches && oe.changedTouches[0]) {
            const t = oe.changedTouches[0];
            return { cx: t.clientX, cy: t.clientY };
        }
        return { cx: e.clientX, cy: e.clientY };
    }

    function hideTooltip() {
        clearTimeout(tooltipTimeout);
        $tooltip.css({ opacity: 0, visibility: 'hidden' });
    }

    function setLinkLoadingState($link, isLoading, loadingLabel = null) {
        if (!$link || !$link.length) {
            return;
        }

        if (isLoading) {
            if (!$link.data('original-label')) {
                const $title = $link.find('.item-title').first();
                const originalLabel = $title.length ? $title.text() : $link.text().trim();
                $link.data('original-label', originalLabel);
            }
            $link.addClass('is-loading-nav').attr('aria-disabled', 'true');
            if (loadingLabel) {
                const $title = $link.find('.item-title').first();
                if ($title.length) {
                    $title.text(loadingLabel);
                } else {
                    $link.text(loadingLabel);
                }
            }
            return;
        }

        $link.removeClass('is-loading-nav').removeAttr('aria-disabled');
        const originalLabel = $link.data('original-label');
        if (originalLabel) {
            const $title = $link.find('.item-title').first();
            if ($title.length) {
                $title.text(originalLabel);
            } else {
                $link.text(originalLabel);
            }
        }
    }

    function bindLinkLoadingFeedback(selector) {
        $(document).on('click', selector, function (event) {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                return;
            }
            if (typeof event.which === 'number' && event.which !== 1) {
                return;
            }

            const $link = $(this);
            const href = $link.attr('href') || '';
            const target = ($link.attr('target') || '').toLowerCase();
            if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || target === '_blank') {
                return;
            }

            if ($link.data('navPending')) {
                event.preventDefault();
                return;
            }

            const loadingLabel = $link.attr('data-loading-label') || null;
            $link.data('navPending', true);
            setLinkLoadingState($link, true, loadingLabel);

            window.setTimeout(function () {
                $link.data('navPending', false);
                setLinkLoadingState($link, false);
            }, 2500);
        });
    }

    function initHomeFeatureCardNavigation() {
        const $cards = $('.template-index .home-feature-card[data-home-target]');
        if (!$cards.length) {
            return;
        }

        const isInteractiveElement = ($target) => $target.closest('a, button, input, select, textarea, summary, label').length > 0;
        const navigateCard = ($card) => {
            const target = $card.attr('data-home-target');
            if (!target || $card.data('navPending')) {
                return;
            }

            $card.data('navPending', true).addClass('is-navigating');
            if (window.gtag) {
                gtag('event', 'home_feature_click', { target });
            }
            window.setTimeout(() => window.location.assign(target), 90);
        };

        $cards.attr('tabindex', '0').attr('role', 'link');

        $cards.on('click', function (event) {
            if (isInteractiveElement($(event.target))) {
                return;
            }
            navigateCard($(this));
        });

        $cards.on('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }
            event.preventDefault();
            navigateCard($(this));
        });
    }

    function initMobileHomeSliders() {
        $('.template-index [data-mobile-slider]').each(function () {
            const $track = $(this);
            const $items = $track.children();
            const $controls = $track.next('[data-mobile-slider-controls]');

            if ($items.length < 2 || !$controls.length) {
                return;
            }

            const $dots = $controls.find('[data-mobile-slider-dots]');
            const $previous = $controls.find('[data-mobile-slider-previous]');
            const $next = $controls.find('[data-mobile-slider-next]');
            const dotLabel = $controls.attr('data-dot-label') || 'Show item __INDEX__';
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            let activeIndex = 0;
            let animationFrame = null;

            const itemTarget = (index) => {
                const firstItem = $items.get(0);
                const item = $items.get(index);
                return item && firstItem ? item.offsetLeft - firstItem.offsetLeft : 0;
            };

            const updateControls = () => {
                const scrollLeft = $track.scrollLeft();
                let closestDistance = Number.POSITIVE_INFINITY;

                $items.each(function (index) {
                    const distance = Math.abs(itemTarget(index) - scrollLeft);
                    if (distance < closestDistance) {
                        closestDistance = distance;
                        activeIndex = index;
                    }
                });

                $dots.children().each(function (index) {
                    $(this)
                        .toggleClass('is-active', index === activeIndex)
                        .attr('aria-current', index === activeIndex ? 'true' : 'false');
                });
                $previous.prop('disabled', activeIndex === 0);
                $next.prop('disabled', activeIndex === $items.length - 1);
            };

            const goTo = (index) => {
                const boundedIndex = Math.max(0, Math.min(index, $items.length - 1));
                $track.get(0).scrollTo({
                    left: itemTarget(boundedIndex),
                    behavior: reduceMotion ? 'auto' : 'smooth'
                });
            };

            $items.each(function (index) {
                $('<button>', {
                    type: 'button',
                    class: 'mobile-slider__dot',
                    'aria-label': dotLabel.replace('__INDEX__', String(index + 1))
                }).on('click', function () {
                    goTo(index);
                }).appendTo($dots);
            });

            $previous.on('click', function () {
                goTo(activeIndex - 1);
            });
            $next.on('click', function () {
                goTo(activeIndex + 1);
            });
            $track.on('scroll', function () {
                if (animationFrame !== null) {
                    window.cancelAnimationFrame(animationFrame);
                }
                animationFrame = window.requestAnimationFrame(function () {
                    animationFrame = null;
                    updateControls();
                });
            });
            $(window).on('resize', updateControls);

            $track.attr('tabindex', '0');
            $controls.addClass('is-ready');
            updateControls();
        });
    }

    function initHomepageBonusVote() {
        const $form = $('.template-index .bonus-vote__form');
        if (!$form.length) {
            return;
        }

        const limit = Number.parseInt($form.attr('data-limit') || '1', 10) || 1;
        const statusTemplate = $form.attr('data-status-template') || '__SELECTED__/__LIMIT__';
        const submitLabel = $form.attr('data-submit-label') || 'Save';
        const savingLabel = $form.attr('data-saving-label') || 'Saving...';
        const errorLabel = $form.attr('data-error-label') || 'Unable to save';
        const votesSuffix = $form.attr('data-votes-suffix') || 'votes';
        const emptyResults = $form.attr('data-empty-results') || '';
        const $status = $form.find('.bonus-vote__status');
        const $ballotCount = $form.find('.bonus-vote__ballot-count');
        const $feedback = $form.find('.bonus-vote__feedback');
        const $submit = $form.find('.bonus-vote__submit');
        const $inputs = $form.find('input[type="checkbox"]');

        const renderStatus = () => {
            const selected = $inputs.filter(':checked').length;
            $status.text(
                statusTemplate
                    .replace('__SELECTED__', String(selected))
                    .replace('__LIMIT__', String(limit))
            );

            const isAtLimit = selected >= limit;
            $inputs.each(function () {
                const $input = $(this);
                const checked = $input.is(':checked');
                const shouldDisable = isAtLimit && !checked;
                $input.prop('disabled', shouldDisable);
                $input.closest('.bonus-vote__option')
                    .toggleClass('is-selected', checked)
                    .toggleClass('is-disabled', shouldDisable);
            });
        };

        const applyPollData = (poll) => {
            if (!poll || !Array.isArray(poll.candidates)) {
                return;
            }

            if (typeof poll.ballot_count !== 'undefined') {
                $ballotCount.text(String(poll.ballot_count));
            }

            poll.candidates.forEach(candidate => {
                const $option = $form.find(`.bonus-vote__option[data-key="${candidate.key}"]`);
                if (!$option.length) {
                    return;
                }

                $option.find('input[type="checkbox"]').prop('checked', !!candidate.selected);
                $option.find('.bonus-vote__count').text(String(candidate.votes || 0));
                $option.find('.bonus-vote__count-label').text(votesSuffix);
                $option.find('.bonus-vote__percent').text(`${candidate.percent || 0}%`);
                $option.find('.bonus-vote__meter-fill').css('width', `${candidate.percent || 0}%`);
            });

            renderStatus();
        };

        $form.on('change', 'input[type="checkbox"]', function () {
            if ($inputs.filter(':checked').length > limit) {
                $(this).prop('checked', false);
            }
            $feedback.removeClass('is-error is-success').text('');
            renderStatus();
        });

        $form.on('submit', function (event) {
            event.preventDefault();
            $submit.prop('disabled', true).text(savingLabel);
            $feedback.removeClass('is-error is-success').text('');

            $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                data: $form.serialize(),
                dataType: 'json'
            }).done(function (response) {
                if (!response || !response.success) {
                    $feedback.addClass('is-error').text((response && response.message) || errorLabel);
                    return;
                }

                applyPollData(response.poll);
                $feedback.addClass('is-success').text(response.message || submitLabel);
            }).fail(function (xhr) {
                let message = errorLabel;
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    message = xhr.responseJSON.message;
                }
                $feedback.addClass('is-error').text(message);
            }).always(function () {
                $submit.prop('disabled', false).text(submitLabel);
            });
        });

        renderStatus();
    }

    function initLocalTimes() {
        const timeElements = document.querySelectorAll('[data-local-time][data-source-time-zone]');
        const dateTimeElements = document.querySelectorAll('[data-local-date-time]');
        if ((!timeElements.length && !dateTimeElements.length) || !window.Intl || typeof Intl.DateTimeFormat !== 'function') {
            return;
        }

        const locale = document.documentElement.lang || navigator.language || undefined;

        function getTimeZoneParts(date, timeZone) {
            const formatter = new Intl.DateTimeFormat('en-US', {
                timeZone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hourCycle: 'h23'
            });
            const values = {};
            formatter.formatToParts(date).forEach((part) => {
                if (part.type !== 'literal') {
                    values[part.type] = parseInt(part.value, 10);
                }
            });
            return values;
        }

        function getTimeZoneOffsetMs(date, timeZone) {
            const parts = getTimeZoneParts(date, timeZone);
            const asUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second || 0);
            return asUtc - date.getTime();
        }

        function zonedTimeToDate(year, month, day, hour, minute, timeZone) {
            const targetUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
            let timestamp = targetUtc;

            for (let i = 0; i < 3; i += 1) {
                timestamp = targetUtc - getTimeZoneOffsetMs(new Date(timestamp), timeZone);
            }

            return new Date(timestamp);
        }

        function addDays(parts, days) {
            const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days, 12, 0, 0));
            return {
                year: date.getUTCFullYear(),
                month: date.getUTCMonth() + 1,
                day: date.getUTCDate()
            };
        }

        const localTimeFormatter = new Intl.DateTimeFormat(locale, {
            hour: 'numeric',
            minute: '2-digit'
        });

        function formatLocalTime(date) {
            if (String(locale || '').toLowerCase().startsWith('fr')) {
                return date.getHours() + 'h' + String(date.getMinutes()).padStart(2, '0');
            }

            return localTimeFormatter.format(date);
        }

        const localShortDateTimeFormatter = new Intl.DateTimeFormat(locale, {
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit'
        });

        function formatLocalDateTime(date) {
            if (String(locale || '').toLowerCase().startsWith('fr')) {
                return String(date.getDate()).padStart(2, '0') + '/'
                    + String(date.getMonth() + 1).padStart(2, '0') + ' '
                    + date.getHours() + 'h' + String(date.getMinutes()).padStart(2, '0');
            }

            return localShortDateTimeFormatter.format(date);
        }

        timeElements.forEach((element) => {
            const time = element.getAttribute('data-local-time') || '';
            const timeZone = element.getAttribute('data-source-time-zone') || '';
            const match = time.match(/^(\d{1,2}):(\d{2})$/);

            if (!match || !timeZone) {
                return;
            }

            const hour = parseInt(match[1], 10);
            const minute = parseInt(match[2], 10);
            const now = new Date();
            let sourceDate = getTimeZoneParts(now, timeZone);
            let eventDate = zonedTimeToDate(sourceDate.year, sourceDate.month, sourceDate.day, hour, minute, timeZone);

            if (eventDate.getTime() < now.getTime()) {
                sourceDate = addDays(sourceDate, 1);
                eventDate = zonedTimeToDate(sourceDate.year, sourceDate.month, sourceDate.day, hour, minute, timeZone);
            }

            element.setAttribute('title', element.textContent.trim());
            element.textContent = formatLocalTime(eventDate);
        });

        dateTimeElements.forEach((element) => {
            const rawDateTime = element.getAttribute('data-local-date-time') || '';
            const date = new Date(rawDateTime);

            if (!rawDateTime || Number.isNaN(date.getTime())) {
                return;
            }

            element.setAttribute('title', element.textContent.trim());
            element.textContent = formatLocalDateTime(date);
        });
    }

    bindLinkLoadingFeedback('a[href^="/sign-up"], .template-index a.home-nav-feedback');
    initHomeFeatureCardNavigation();
    initMobileHomeSliders();
    initHomepageBonusVote();
    initLocalTimes();

    // === Bindings
    function rebindTooltips($scope) {
        const bind = (selector, getContent) => {
            $scope.find(selector)
                .off('.tt')
                .on('mouseenter.tt touchstart.tt', function (e) { showTooltip(e, $(this), getContent); })
                .on('mousemove.tt touchmove.tt', function (e) { showTooltip(e, $(this), getContent); })
                .on('focusin.tt', function (e) { showTooltip(e, $(this), getContent); })
                .on('mouseleave.tt touchend.tt touchcancel.tt focusout.tt', hideTooltip);
        };

        bind('.card-bonuses .tooltip', $el => $el.attr('data-title') || '');
        bind('.card-attack-defense', getAttackDefenseBonuses);
        bind('.card-level.tooltip', $el => $el.attr('data-title') || '');
        bind('.ascension-progress__item.tooltip', $el => $el.attr('data-title') || '');
    }

    rebindTooltips($(document));
    window.rebindTooltips = rebindTooltips;
    syncHeaderHeightVar();
    $(window).on('resize orientationchange load scroll', scheduleHeaderHeightSync);

    function getAttackDefenseBonuses($element) {
        let bonuses = $element.find('.attack-defense-bonus li').map(function () {
            return $(this).text().trim();
        }).get();

        return bonuses.length ? bonuses.join('<br>') : null;
    }

    // Animation des cartes
    function revealCards($scope = $(document)) {
        const $unrevealedCards = ($scope && $scope.length ? $scope : $(document)).find('.card.unrevealed');
        $unrevealedCards.css({ opacity: 0 }).show();

        $unrevealedCards.each(function (index) {
            $(this).delay(index * 300).animate({ opacity: 1 }, 500);
        });
    }

    function preloadUnrevealedBack() {
        return new Promise(resolve => {
            const img = new Image();
            const done = () => resolve();

            img.onload = done;
            img.onerror = done;
            img.src = '/img/unrevealed.png';

            if (img.complete) {
                resolve();
            } else {
                setTimeout(done, 1500);
            }
        });
    }

    const boosterRevealRootSelector = 'body.template-open-booster, body.template-claim-reward';
    const boosterRevealPendingClass = 'booster-reveal-pending';
    const $boosterRevealRoot = $(boosterRevealRootSelector);
    const isBoosterRevealPage = $boosterRevealRoot.length > 0;
    const isOpenBoosterPage = $('body.template-open-booster').length > 0;
    let boosterHeightRaf = null;
    let boosterRevealStarted = false;
    let boosterRevealFinished = false;
    let allowBoosterPageLeave = false;
    let boosterCollectionRedirectTimeout = null;

    function getBoosterRevealCards() {
        if (!isBoosterRevealPage) {
            return $();
        }

        return $boosterRevealRoot.find('.card');
    }

    function getPendingBoosterRevealCards() {
        return getBoosterRevealCards().filter('.unrevealed');
    }

    function hasPendingBoosterReveals() {
        return getPendingBoosterRevealCards().length > 0;
    }

    function getBoosterLeaveConfirmMessage() {
        return t('js.open_booster.leave_confirm');
    }

    function allowBoosterPageLeaveOnce() {
        allowBoosterPageLeave = true;
        setTimeout(() => {
            allowBoosterPageLeave = false;
        }, 1000);
    }

    function scheduleBoosterCollectionRedirect() {
        if (!isOpenBoosterPage || !$boosterRevealRoot.hasClass('has-onboarding-journey') || boosterCollectionRedirectTimeout) {
            return;
        }

        const $collectionLink = $boosterRevealRoot.find('#open-booster-action a[href^="/collection"]').first();
        if (!$collectionLink.length || !$collectionLink.is(':visible')) {
            return;
        }

        boosterCollectionRedirectTimeout = setTimeout(() => {
            const targetUrl = $collectionLink.attr('href') || '/collection?clear_filters=1';
            allowBoosterPageLeaveOnce();
            setLinkLoadingState($collectionLink, true, t('js.common.loading'));
            window.location.assign(targetUrl);
        }, 4000);
    }

    function isOpenBoosterSelfSubmit(formElement) {
        if (!isOpenBoosterPage || !formElement) {
            return false;
        }

        const action = ($(formElement).attr('action') || '').trim();
        if (!action) {
            return false;
        }

        try {
            return new URL(action, window.location.origin).pathname === '/open-booster';
        } catch (error) {
            return action === '/open-booster';
        }
    }

    function syncBoosterSliderHeight() {
        if (!isBoosterRevealPage) {
            return;
        }

        const $action = $boosterRevealRoot.find('#open-booster-action');
        const $actionContainer = $action.closest('.open-booster-container');
        const actionHeight = ($actionContainer.length ? $actionContainer.outerHeight(true) : $action.outerHeight(true)) || 0;
        const { height: headerHeight, offset: headerOffset } = getHeaderMetrics();
        const onboardingHeight = $('.onboarding-journey').outerHeight(true) || 0;
        const footerHeight = $('#footer').outerHeight(true) || 0;

        document.documentElement.style.setProperty('--open-booster-action-height', `${actionHeight}px`);
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        document.documentElement.style.setProperty('--header-offset', `${headerOffset}px`);
        document.documentElement.style.setProperty('--onboarding-journey-height', `${onboardingHeight}px`);
        document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
    }

    function scheduleBoosterSliderHeight() {
        if (!isBoosterRevealPage) {
            return;
        }

        if (boosterHeightRaf) {
            cancelAnimationFrame(boosterHeightRaf);
        }

        boosterHeightRaf = requestAnimationFrame(() => {
            boosterHeightRaf = null;
            syncBoosterSliderHeight();
        });
    }

    function finalizeBoosterReveal() {
        if (boosterRevealFinished) {
            return;
        }

        boosterRevealFinished = true;
        $boosterRevealRoot.removeClass(boosterRevealPendingClass);

        const $pendingCards = getPendingBoosterRevealCards();
        if ($pendingCards.length) {
            $pendingCards.css({ visibility: 'visible' }).addClass('unrevealed-ready');
        }

        revealCards($boosterRevealRoot);
    }

    function startBoosterReveal() {
        if (!isBoosterRevealPage || boosterRevealStarted) {
            return;
        }

        boosterRevealStarted = true;

        const $pendingCards = getPendingBoosterRevealCards();
        if ($pendingCards.length) {
            $boosterRevealRoot.addClass(boosterRevealPendingClass);
            $pendingCards.css({ visibility: 'hidden' });
            preloadUnrevealedBack()
                .then(finalizeBoosterReveal)
                .catch(finalizeBoosterReveal);

            // Safety net: never leave booster cards hidden if another script breaks the flow.
            setTimeout(finalizeBoosterReveal, 1800);
            return;
        }

        finalizeBoosterReveal();
    }

    if (isBoosterRevealPage) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', startBoosterReveal, { once: true });
        } else {
            startBoosterReveal();
        }
    }

    if (isOpenBoosterPage) {
        $(window).on('beforeunload.openBoosterRevealGuard', function (e) {
            if (allowBoosterPageLeave || !hasPendingBoosterReveals()) {
                return undefined;
            }

            const message = getBoosterLeaveConfirmMessage();
            const nativeEvent = e.originalEvent || e;

            if (nativeEvent && typeof nativeEvent.preventDefault === 'function') {
                nativeEvent.preventDefault();
            }
            if (nativeEvent) {
                nativeEvent.returnValue = message;
            }

            return message;
        });

        $(document).on('click.openBoosterRevealGuard', 'a', function (e) {
            if (allowBoosterPageLeave || !hasPendingBoosterReveals()) {
                return;
            }

            if (e.which && e.which !== 1) {
                return;
            }

            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
                return;
            }

            const $link = $(this);
            const href = ($link.attr('href') || '').trim();
            const target = ($link.attr('target') || '').trim().toLowerCase();

            if (!href || href === '#' || href.startsWith('javascript:') || target === '_blank') {
                return;
            }

            if (!window.confirm(getBoosterLeaveConfirmMessage())) {
                e.preventDefault();
                return;
            }

            allowBoosterPageLeaveOnce();
        });

        $(document).on('submit.openBoosterRevealGuard', 'form', function (e) {
            if (isOpenBoosterSelfSubmit(this)) {
                allowBoosterPageLeaveOnce();
                return;
            }

            if (allowBoosterPageLeave || !hasPendingBoosterReveals()) {
                return;
            }

            if (!window.confirm(getBoosterLeaveConfirmMessage())) {
                e.preventDefault();
                return;
            }

            allowBoosterPageLeaveOnce();
        });
    }

    scheduleBoosterSliderHeight();
    $(window).on('resize orientationchange', scheduleBoosterSliderHeight);

    let $activeBoosterCard = null;
    let lowLevelAutoAdvanceTimeout = null;

    function scrollCardIntoView($card, behavior = 'smooth') {
        if (!$card || !$card.length) {
            return;
        }
        const slideEl = $card.closest('.booster-slide').get(0) || $card.get(0);
        if (!slideEl || typeof slideEl.scrollIntoView !== 'function') {
            return;
        }
        slideEl.scrollIntoView({ behavior, inline: 'center', block: 'nearest' });
    }

    function clearLowLevelAutoAdvance() {
        if (lowLevelAutoAdvanceTimeout) {
            clearTimeout(lowLevelAutoAdvanceTimeout);
            lowLevelAutoAdvanceTimeout = null;
        }
    }

    function getNextUnrevealedCard($fromCard) {
        const $cards = getBoosterRevealCards();
        if (!$cards.length) {
            return $();
        }

        if ($fromCard && $fromCard.length) {
            const currentIndex = $cards.index($fromCard);
            if (currentIndex !== -1) {
                for (let i = currentIndex + 1; i < $cards.length; i++) {
                    const $candidate = $cards.eq(i);
                    if ($candidate.hasClass('unrevealed')) {
                        return $candidate;
                    }
                }
            }
        }

        return $();
    }

    function getPrevCard($fromCard) {
        const $cards = getBoosterRevealCards();
        if (!$cards.length) {
            return $();
        }

        if ($fromCard && $fromCard.length) {
            const currentIndex = $cards.index($fromCard);
            if (currentIndex > 0) {
                return $cards.eq(currentIndex - 1);
            }
        }

        return $();
    }

    function getNextCard($fromCard) {
        const $cards = getBoosterRevealCards();
        if (!$cards.length) {
            return $();
        }

        const $currentCard = ($fromCard && $fromCard.length)
            ? $fromCard
            : $cards.first();
        const currentIndex = $cards.index($currentCard);

        if (currentIndex !== -1 && currentIndex < $cards.length - 1) {
            return $cards.eq(currentIndex + 1);
        }

        return $();
    }

    function renderBoosterPeek($fromCard = $activeBoosterCard) {
        const $peekNext = $boosterRevealRoot.find('.booster-next-peek');
        const $peekPrev = $boosterRevealRoot.find('.booster-prev-peek');
        if (!$peekNext.length && !$peekPrev.length) {
            return;
        }

        const $cards = getBoosterRevealCards();
        if (!$cards.length) {
            $peekPrev.removeClass('visible');
            $peekNext.removeClass('visible');
            return;
        }

        const $currentCard = ($fromCard && $fromCard.length)
            ? $fromCard
            : $cards.first();
        const currentIndex = $cards.index($currentCard);

        const hasPrev = currentIndex > 0;
        const hasNext = currentIndex !== -1 && currentIndex < $cards.length - 1;

        $peekPrev.toggleClass('visible', hasPrev);
        $peekNext.toggleClass('visible', hasNext);
    }

    function setActiveBoosterCard($card) {
        if (!$card || !$card.length || !$card.closest(boosterRevealRootSelector).length) {
            return;
        }

        $boosterRevealRoot.find('.booster-slide.is-active').removeClass('is-active');
        $card.closest('.booster-slide').addClass('is-active');
        $activeBoosterCard = $card;
        renderBoosterPeek($card);
    }

    function getAutoAdvanceDelay(cardLevel) {
        if (Number.isNaN(cardLevel)) {
            return null;
        }

        if (cardLevel <= 1) {
            return 800;
        }

        if (cardLevel === 2) {
            return 1600;
        }

        return null;
    }

    function scheduleLowLevelAutoAdvance($card) {
        if (!$card || !$card.length) {
            return;
        }

        clearLowLevelAutoAdvance();

        const cardLevel = parseInt($card.attr('data-level'), 10);
        const delay = getAutoAdvanceDelay(cardLevel);
        if (!delay) {
            return;
        }

        lowLevelAutoAdvanceTimeout = setTimeout(() => {
            lowLevelAutoAdvanceTimeout = null;

            if (getPendingBoosterRevealCards().length === 0) {
                return;
            }

            if (!$card.closest(boosterRevealRootSelector).length) {
                return;
            }

            const $nextCard = getNextUnrevealedCard($activeBoosterCard);
            if (!$nextCard.length) {
                return;
            }

            advanceToNextUnrevealed();
        }, delay);
    }

    function advanceToNextUnrevealed() {
        const $nextCard = getNextUnrevealedCard($activeBoosterCard);
        if (!$nextCard.length) {
            return;
        }

        setActiveBoosterCard($nextCard);
        scrollCardIntoView($nextCard);
        $nextCard.addClass('booster-target');
        setTimeout(() => $nextCard.removeClass('booster-target'), 650);
    }

    function advanceToNextCard() {
        const $nextCard = getNextCard($activeBoosterCard);
        if (!$nextCard.length) {
            return;
        }

        setActiveBoosterCard($nextCard);
        scrollCardIntoView($nextCard);
    }

    function goToPreviousCard() {
        const $prevCard = getPrevCard($activeBoosterCard);
        if (!$prevCard.length) {
            return;
        }

        setActiveBoosterCard($prevCard);
        scrollCardIntoView($prevCard);
    }

    function autoScrollAfterFirstThreeRevealed() {
        if (window.innerWidth < 1024) {
            return;
        }

        const revealedCount = getBoosterRevealCards().not('.unrevealed').length;
        if (revealedCount !== 3) {
            return;
        }

        const $nextCard = getNextUnrevealedCard($activeBoosterCard);
        if (!$nextCard.length) {
            return;
        }

        setActiveBoosterCard($nextCard);
        scrollCardIntoView($nextCard);
        $nextCard.addClass('booster-target');
        setTimeout(() => $nextCard.removeClass('booster-target'), 650);
    }

    function handleCardClick() {
        clearLowLevelAutoAdvance();
        const $card = $(this);
        const $cardBack = $card.find('.card-back');
        const $cardName = $card.find('.card-name');
        const cardLevel = parseInt($card.attr('data-level'), 10);
        $cardName.css('opacity', 0);

        if ($card.closest(boosterRevealRootSelector).length) {
            setActiveBoosterCard($card);
        }

        $cardBack.fadeOut(500, function () {
            $card.removeClass('unrevealed');
            $cardBack.remove();

            if (!Number.isNaN(cardLevel) && cardLevel > 2) {
                $card.addClass('booster-reveal-halo');
            }

            applyCircleType($card);
            $cardName.stop(true, true).fadeTo(300, 1);

            if ($card.hasClass('race-abnormality')) {
                const audio = new Audio('audio/abnormality.mp3');
                audio.play();
            }

            if (getPendingBoosterRevealCards().length === 0) {
                $boosterRevealRoot.find('#open-booster-action a, #open-booster-action button')
                    .css('display', 'inline-block')
                    .fadeIn(500, function () {
                        scheduleBoosterSliderHeight();
                        scheduleBoosterCollectionRedirect();
                    });
            }

            renderBoosterPeek($card);
            autoScrollAfterFirstThreeRevealed();
            scheduleLowLevelAutoAdvance($card);
        });
    }

    if (isBoosterRevealPage) {
        $boosterRevealRoot.on('click', '.card.unrevealed', handleCardClick);
        $boosterRevealRoot.on('click', '.card', function () {
            setActiveBoosterCard($(this));
        });
        $boosterRevealRoot.on('click', '.booster-next-peek', function (e) {
            e.preventDefault();
            clearLowLevelAutoAdvance();
            advanceToNextCard();
        });
        $boosterRevealRoot.on('click', '.booster-prev-peek', function (e) {
            e.preventDefault();
            clearLowLevelAutoAdvance();
            goToPreviousCard();
        });
    }

    function initBoosterPeekState() {
        const $firstCard = getBoosterRevealCards().first();
        if ($firstCard.length) {
            setActiveBoosterCard($firstCard);
            scrollCardIntoView($firstCard, 'auto');
        } else {
            renderBoosterPeek();
        }
    }

    initBoosterPeekState();

    function zoomCard($card) {
        const $clonedCard = $card.clone();
        clearCardTiltArtifacts($clonedCard.get(0));
        $clonedCard.find('.card-actions').remove();
        $clonedCard.addClass('zoomed');

        const cardId = $card.data('id');
        const downloadUrl = `/download-${cardId}`;

        const $container = $('<div class="zoom-container"></div>').append($clonedCard);

        const $downloadLink = $('<a>')
            .attr('href', downloadUrl)
            .attr('target', '_blank')
            .text(t('js.common.download_illustration'))
            .addClass('cta');

        /* ───── masquer tant que la carte est unrevealed ───── */
        if ($clonedCard.hasClass('unrevealed')) {
            $downloadLink.hide();                                 // 1. on cache

            // 2. on écoute la disparition de la classe .unrevealed
            const observer = new MutationObserver(() => {
                if (!$clonedCard.hasClass('unrevealed')) {
                    $downloadLink.fadeIn(300);                    // affichage doux
                    observer.disconnect();                       // on n’écoute plus
                }
            });
            observer.observe($clonedCard[0], {
                attributes: true,
                attributeFilter: ['class']
            });
        }

        $container.append($downloadLink);

        rebindTooltips($clonedCard);
        return $container;
    }




    window.zoomCard = zoomCard;



    function showCardInLightbox($card) {
        const $zoomedCard = zoomCard($card); // Préparer la carte avec zoom
        handleLightbox($zoomedCard);         // Afficher dans la lightbox

        $zoomedCard.on('click', function (e) {
            e.stopPropagation(); // Empêche la fermeture de la lightbox quand on clique sur la carte zoomée
        });
    }



    // Gestion du zoom sur les cartes déjà révélées
    $('.template-open-booster, .template-deck, #catalyst.successful-diver, .template-profil, .template-divinities-gallery').on('click', '.card:not(.unrevealed)', function (e) {
        e.preventDefault();
        const $card = $(this);
        showCardInLightbox($card);
    });

    let avatarPickerInitialized = false;
    let avatarObserver = null;

    function loadAvatarPreview(el) {
        const $el = $(el);
        if ($el.data('avatarLoaded')) {
            return;
        }

        const src = $el.data('avatar-src');
        if (!src) {
            return;
        }

        $el.css('background-image', 'url(' + src + ')');
        $el.data('avatarLoaded', true);
    }

    function initAvatarPickerLazyLoad() {
        if (avatarPickerInitialized) {
            return;
        }
        avatarPickerInitialized = true;

        const $items = $('#choose-avatar li');
        if ($items.length === 0) {
            return;
        }

        if ('IntersectionObserver' in window) {
            avatarObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        loadAvatarPreview(entry.target);
                        avatarObserver.unobserve(entry.target);
                    }
                });
            }, {
                root: document.getElementById('choose-avatar'),
                rootMargin: '120px 0px'
            });

            $items.each(function () {
                avatarObserver.observe(this);
            });
            return;
        }

        $items.each(function () {
            loadAvatarPreview(this);
        });
    }

    $('#choose-avatar-btn').on('click', function (e) {
        e.preventDefault();
        const $picker = $('#choose-avatar');
        const shouldOpen = !$picker.hasClass('is-open');
        $picker.toggleClass('is-open', shouldOpen);
        $(this).attr('aria-expanded', shouldOpen ? 'true' : 'false');
        if (shouldOpen) {
            initAvatarPickerLazyLoad();
        }
    });

    $('#choose-avatar').on('keydown', 'li', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') {
            return;
        }
        e.preventDefault();
        $(this).trigger('click');
    });

    $('#choose-avatar').on('click', 'li', function (e) {
        $('#choose-avatar li').removeClass('active').attr('aria-pressed', 'false');
        $(this).addClass('active').attr('aria-pressed', 'true');
        var avatarId = $(this).data('id');
        $.post(window.location.href, { avatar: avatarId }).done(function (response) {
            $('#account-header .avatar').css('background-image', 'url(cards/' + avatarId + '.webp)');
            $('#choose-avatar').removeClass('is-open');
            $('#choose-avatar-btn').attr('aria-expanded', 'false');
            $('#choose-avatar-btn').trigger('focus');
        });
    });

    function initAccountMobileOrder() {
        const layout = document.querySelector('.account-layout');
        const side = layout ? layout.querySelector('.account-layout__side') : null;
        const main = layout ? layout.querySelector('.account-layout__main') : null;
        const quests = side ? side.querySelector('.account-quests') : null;
        const decks = main ? main.querySelector('.account-decks') : null;

        if (!layout || !side || !main || !decks) {
            return;
        }

        const mobileMedia = window.matchMedia('(max-width: 800px)');

        function syncOrder() {
            if (mobileMedia.matches) {
                if (quests) {
                    quests.insertAdjacentElement('afterend', decks);
                } else {
                    side.insertBefore(decks, side.firstElementChild);
                }
                return;
            }

            main.appendChild(decks);
        }

        syncOrder();
        if (typeof mobileMedia.addEventListener === 'function') {
            mobileMedia.addEventListener('change', syncOrder);
        } else {
            mobileMedia.addListener(syncOrder);
        }
    }

    initAccountMobileOrder();

    function loadAccountAsyncSection(container) {
        const $container = $(container);
        const url = $container.data('accountSectionUrl');
        const bypassCache = $container.data('accountSectionCache') === 'bypass';
        if (!url || $container.data('accountSectionLoaded')) {
            return;
        }

        $container.data('accountSectionLoaded', true).addClass('is-loading');

        $.ajax({
            url: url,
            method: 'GET',
            cache: !bypassCache
        })
            .done(function (html) {
                $container.html(html || '');
                applyCircleType($container);
                initLocalTimes();
            })
            .fail(function () {
                $container.data('accountSectionLoaded', false);
            })
            .always(function () {
                $container.removeClass('is-loading');
            });
    }

    function initAccountAsyncSections() {
        const $sections = $('.account-async-section[data-account-section-url]');
        if ($sections.length === 0) {
            return;
        }

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        loadAccountAsyncSection(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                rootMargin: '240px 0px'
            });

            $sections.each(function () {
                observer.observe(this);
            });
            return;
        }

        $sections.each(function () {
            loadAccountAsyncSection(this);
        });
    }

    initAccountAsyncSections();

    applyCircleType();

    function usesChromiumEngine() {
        const userAgentData = window.navigator.userAgentData;
        if (userAgentData && Array.isArray(userAgentData.brands)) {
            return userAgentData.brands.some(function (entry) {
                return entry && entry.brand === 'Chromium';
            });
        }

        const userAgent = window.navigator.userAgent || '';
        const isAppleMobile = /iPhone|iPad|iPod/i.test(userAgent);
        return !isAppleMobile
            && /(?:Chrom(?:e|ium)|Edg|OPR|SamsungBrowser)\//i.test(userAgent);
    }

    const cardTiltChromiumEngine = usesChromiumEngine();
    const cardTiltPointerMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    const cardTiltReducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
    const cardTiltStates = new Map();
    const cardTiltIdentityTransform = 'matrix(1, 0, 0, 1, 0, 0)';
    const cardTiltEmptyShadow = '0 0 0 rgba(0, 0, 0, 0)';
    const cardTiltStyleProperties = [
        '--card-tilt-base-transform',
        '--card-tilt-base-shadow',
        '--card-tilt-perspective',
        '--card-tilt-x',
        '--card-tilt-y',
        '--card-tilt-lift',
        '--card-tilt-depth',
        '--card-tilt-scale',
        '--card-tilt-progress',
        '--card-tilt-shadow-x',
        '--card-tilt-shadow-y',
        '--card-tilt-shadow-blur',
        '--card-tilt-shadow-opacity',
        '--card-glare-x',
        '--card-glare-y',
        '--card-glare-opacity',
        '--card-shade-angle',
        '--card-edge-glow'
    ];

    function clampCardTilt(value, min, max) {
        return Math.min(max, Math.max(min, value));
    }

    function getCardTiltOriginalStyles(card) {
        const styles = new Map();

        cardTiltStyleProperties.forEach(function (property) {
            styles.set(property, {
                value: card.style.getPropertyValue(property),
                priority: card.style.getPropertyPriority(property)
            });
        });

        return styles;
    }

    function restoreCardTiltStyles(card, styles) {
        cardTiltStyleProperties.forEach(function (property) {
            const original = styles ? styles.get(property) : null;

            if (original && original.value) {
                card.style.setProperty(property, original.value, original.priority);
                return;
            }

            card.style.removeProperty(property);
        });
    }

    function clearCardTiltArtifacts(card) {
        if (!card) {
            return;
        }

        const state = cardTiltStates.get(card);
        if (state) {
            finishCardTilt(state);
            return;
        }

        card.classList.remove('is-tilting');
        restoreCardTiltStyles(card);
    }

    function isCardTiltEligible(card) {
        if (
            !card
            || !cardTiltChromiumEngine
            || !cardTiltPointerMedia.matches
            || cardTiltReducedMotionMedia.matches
        ) {
            return false;
        }

        if (card.closest('.template-play, .deck-dragging')) {
            return false;
        }

        return !card.matches([
            '.zoomed',
            '.unrevealed',
            '.motion',
            '.attacking',
            '.booster-target',
            '.catalyst-locked',
            '.catalyst-bulk-selected',
            '.sortable-chosen',
            '.sortable-ghost',
            '.sortable-drag'
        ].join(', '));
    }

    function applyCardTiltFrame(state) {
        const card = state.card;
        const progress = state.progress;
        const intensity = Math.min(1, Math.hypot(state.x, state.y) / Math.SQRT2);
        const shadeAngle = (Math.atan2(state.y, state.x) * 180 / Math.PI + 90 + 360) % 360;
        const depth = Math.min(20, Math.max(10, state.rect.width * 0.055));

        card.style.setProperty('--card-tilt-x', `${-state.y * 8}deg`);
        card.style.setProperty('--card-tilt-y', `${state.x * 9}deg`);
        card.style.setProperty('--card-tilt-lift', `${-progress * 2}px`);
        card.style.setProperty('--card-tilt-depth', `${progress * depth}px`);
        card.style.setProperty('--card-tilt-scale', 1 + progress * 0.018);
        card.style.setProperty('--card-tilt-progress', progress);
        card.style.setProperty('--card-tilt-shadow-x', `${-state.x * 12}px`);
        card.style.setProperty('--card-tilt-shadow-y', `${progress * 7 - state.y * 10}px`);
        card.style.setProperty('--card-tilt-shadow-blur', `${5 + progress * 18}px`);
        card.style.setProperty('--card-tilt-shadow-opacity', progress * 0.38);
        card.style.setProperty('--card-glare-x', `${(state.x + 1) * 50}%`);
        card.style.setProperty('--card-glare-y', `${(state.y + 1) * 50}%`);
        card.style.setProperty('--card-glare-opacity', progress * (0.28 + intensity * 0.42));
        card.style.setProperty('--card-shade-angle', `${shadeAngle}deg`);
        card.style.setProperty('--card-edge-glow', progress * (0.06 + intensity * 0.1));
    }

    function finishCardTilt(state) {
        if (state.frameId !== null) {
            window.cancelAnimationFrame(state.frameId);
        }
        if (state.classObserver) {
            state.classObserver.disconnect();
        }

        state.card.classList.remove('is-tilting');
        restoreCardTiltStyles(state.card, state.originalStyles);
        cardTiltStates.delete(state.card);
    }

    function animateCardTilt(state, timestamp) {
        state.frameId = null;

        if (!state.card.isConnected) {
            finishCardTilt(state);
            return;
        }

        const frameDuration = state.lastFrameTime
            ? clampCardTilt(timestamp - state.lastFrameTime, 1, 34)
            : (1000 / 60);
        const baseEasing = state.active ? 0.22 : 0.18;
        const easing = 1 - Math.pow(1 - baseEasing, frameDuration / (1000 / 60));
        state.lastFrameTime = timestamp;
        state.x += (state.targetX - state.x) * easing;
        state.y += (state.targetY - state.y) * easing;
        state.progress += (state.targetProgress - state.progress) * easing;

        const isSettled = Math.abs(state.targetX - state.x) < 0.001
            && Math.abs(state.targetY - state.y) < 0.001
            && Math.abs(state.targetProgress - state.progress) < 0.001;

        if (isSettled) {
            state.x = state.targetX;
            state.y = state.targetY;
            state.progress = state.targetProgress;
        }

        applyCardTiltFrame(state);

        if (!state.active && isSettled) {
            finishCardTilt(state);
            return;
        }

        if (!isSettled) {
            state.frameId = window.requestAnimationFrame(function (nextTimestamp) {
                animateCardTilt(state, nextTimestamp);
            });
        } else {
            state.lastFrameTime = 0;
        }
    }

    function scheduleCardTilt(state) {
        if (state.frameId !== null) {
            return;
        }

        state.frameId = window.requestAnimationFrame(function (timestamp) {
            animateCardTilt(state, timestamp);
        });
    }

    function updateCardTiltTarget(state, clientX, clientY) {
        const x = clampCardTilt((clientX - state.rect.left) / state.rect.width, 0, 1);
        const y = clampCardTilt((clientY - state.rect.top) / state.rect.height, 0, 1);

        state.targetX = x * 2 - 1;
        state.targetY = y * 2 - 1;
        scheduleCardTilt(state);
    }

    function startCardTilt(card, clientX, clientY) {
        if (!isCardTiltEligible(card)) {
            return;
        }

        let state = cardTiltStates.get(card);
        if (state) {
            state.active = true;
            state.targetProgress = 1;
            updateCardTiltTarget(state, clientX, clientY);
            return;
        }

        const rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) {
            return;
        }

        const computedStyle = window.getComputedStyle(card);
        state = {
            card,
            rect,
            originalStyles: getCardTiltOriginalStyles(card),
            active: true,
            frameId: null,
            lastFrameTime: 0,
            x: 0,
            y: 0,
            progress: 0,
            targetX: 0,
            targetY: 0,
            targetProgress: 1
        };

        card.style.setProperty(
            '--card-tilt-base-transform',
            computedStyle.transform === 'none' ? cardTiltIdentityTransform : computedStyle.transform
        );
        card.style.setProperty(
            '--card-tilt-base-shadow',
            computedStyle.boxShadow === 'none' ? cardTiltEmptyShadow : computedStyle.boxShadow
        );
        card.style.setProperty('--card-tilt-perspective', `${Math.max(700, rect.height * 1.65)}px`);
        card.classList.add('is-tilting');
        cardTiltStates.set(card, state);
        state.classObserver = new MutationObserver(function () {
            if (!isCardTiltEligible(card)) {
                stopCardTilt(card, true);
            }
        });
        state.classObserver.observe(card, {
            attributes: true,
            attributeFilter: ['class']
        });
        updateCardTiltTarget(state, clientX, clientY);
    }

    function stopCardTilt(card, immediate = false) {
        const state = cardTiltStates.get(card);
        if (!state) {
            return;
        }

        state.active = false;
        state.targetX = 0;
        state.targetY = 0;
        state.targetProgress = 0;

        if (immediate) {
            finishCardTilt(state);
            return;
        }

        scheduleCardTilt(state);
    }

    function resetAllCardTilts(immediate = true) {
        Array.from(cardTiltStates.keys()).forEach(function (card) {
            stopCardTilt(card, immediate);
        });
    }

    function getPointerCard(event) {
        return event.target instanceof Element ? event.target.closest('.card') : null;
    }

    function isCardTiltPointer(event) {
        return event.pointerType === 'mouse' || event.pointerType === 'pen';
    }

    document.addEventListener('pointerover', function (event) {
        if (!isCardTiltPointer(event)) {
            return;
        }

        const card = getPointerCard(event);
        if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) {
            return;
        }

        startCardTilt(card, event.clientX, event.clientY);
    });

    document.addEventListener('pointermove', function (event) {
        if (!isCardTiltPointer(event)) {
            return;
        }

        const card = getPointerCard(event);
        if (!card) {
            return;
        }

        if (!isCardTiltEligible(card)) {
            stopCardTilt(card, true);
            return;
        }

        const state = cardTiltStates.get(card);
        if (state) {
            updateCardTiltTarget(state, event.clientX, event.clientY);
        } else {
            startCardTilt(card, event.clientX, event.clientY);
        }
    }, { passive: true });

    document.addEventListener('pointerout', function (event) {
        if (!isCardTiltPointer(event)) {
            return;
        }

        const card = getPointerCard(event);
        if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) {
            return;
        }

        stopCardTilt(card);
    });

    document.addEventListener('pointercancel', function (event) {
        const card = getPointerCard(event);
        if (card) {
            stopCardTilt(card, true);
        }
    });

    window.addEventListener('blur', function () {
        resetAllCardTilts(true);
    });

    document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
            resetAllCardTilts(true);
        }
    });

    [cardTiltPointerMedia, cardTiltReducedMotionMedia].forEach(function (mediaQuery) {
        const handleChange = function () {
            resetAllCardTilts(true);
        };

        if (typeof mediaQuery.addEventListener === 'function') {
            mediaQuery.addEventListener('change', handleChange);
        } else if (typeof mediaQuery.addListener === 'function') {
            mediaQuery.addListener(handleChange);
        }
    });

    const cardTiltDomObserver = new MutationObserver(function () {
        cardTiltStates.forEach(function (state, card) {
            if (!card.isConnected) {
                finishCardTilt(state);
            }
        });
    });
    cardTiltDomObserver.observe(document.body, { childList: true, subtree: true });



    // Fonction pour rafraîchir chaque instance sur changement d'orientation
    function refreshCircles() {
        setTimeout(function () {
            destroyAllCircleTypes();
            applyCircleType();
        }, 200);
    }

    // Ajout de l'écouteur sur `orientationchange`
    $(window).on('orientationchange', refreshCircles);

    // Gestion des actions du deck
    function handleDeckToggle() {
        $(this).toggleClass('up');
        $('#deck-building').slideToggle();
    }

    $('#deck-building-container .menu svg').on('click', handleDeckToggle);


    function destroyCircleTypeElement(nameElement) {
        const circleType = circleTypes.get(nameElement);
        if (circleType) {
            try {
                circleType.destroy();
            } catch (error) {
                console.debug('[CircleType] Unable to destroy an instance.', error);
            }
            circleTypes.delete(nameElement);
        }
        $(nameElement).removeClass('circle-applied');
    }

    function destroyCircleTypesIn($scope) {
        const $names = $scope.is('.card-name')
            ? $scope
            : $scope.find('.card-name');
        $names.each(function () {
            destroyCircleTypeElement(this);
        });
    }

    function destroyAllCircleTypes() {
        Array.from(circleTypes.keys()).forEach(function (nameElement) {
            destroyCircleTypeElement(nameElement);
        });
    }

    function applyCircleType($scope = $(document)) {
        // Prune instances whose virtualized card has left the DOM. Scoped
        // renders explicitly destroy their instances before replacing nodes.
        Array.from(circleTypes.keys()).forEach(function (nameElement) {
            if (!nameElement.isConnected) {
                destroyCircleTypeElement(nameElement);
            }
        });

        const $names = $scope.is('.card-name')
            ? $scope
            : $scope.find('.card-name');

        // Appliquer CircleType seulement sur les éléments qui ne l’ont pas déjà
        $names.each(function () {
            const $name = $(this);
            const $card = $name.closest('.card');
            const isActuallyVisible = $name.is(':visible') && $name.css('visibility') !== 'hidden';
            const hasText = ($name.text() || '').trim().length > 0;
            const canApply = !circleTypes.has(this)
                && !$name.hasClass('circle-applied')
                && isActuallyVisible
                && hasText
                && (!$card.length || !$card.hasClass('unrevealed'));

            if (canApply) {
                const calculatedRadius = $name.outerWidth() * 1.5;
                const circleTypeInstance = new CircleType(this).radius(calculatedRadius);
                circleTypes.set(this, circleTypeInstance);
                $name.addClass('circle-applied');
            }
        });
    }

    window.applyCircleType = applyCircleType;
    window.destroyCircleTypesIn = destroyCircleTypesIn;
    window.getCircleTypeInstanceCount = function () {
        return circleTypes.size;
    };
    $(document).on('lightboxClosed.circleCleanup', function () {
        const $lightbox = $('.lightbox');
        if ($lightbox.length) {
            destroyCircleTypesIn($lightbox);
        }
    });



    function handleDeckActionClick(e) {
        console.log('handleDeckActionClick');
        e.preventDefault();
        if ($(this).hasClass('is-disabled')) {
            return;
        }
        const $card = $(this).closest('.card');
        const cardId = $card.data('id');

        if ($card.hasClass('in-deck')) {
            removeFromDeck($card, cardId);
        } else {
            addToDeck($card);
        }
        updateDeckButtonText();
        sendDeckUpdate();
        updateAddToDeckButtons(); // Update the buttons after deck change

        rebindTooltips($('#deck-building, #collection')); // Rebind tooltips
    }

    function addToDeck($card) {
        if ($('#deck-building').find('.card').length >= 6) {
            return;
        }
        $card.addClass('in-deck');
        const $cardClone = $card.clone();
        clearCardTiltArtifacts($cardClone.get(0));
        $('#deck-building .collection-cards').append($cardClone);
    }

    function removeFromDeck($card, cardId) {
        console.log('removeFromDeck');
        $('.card[data-id="' + cardId + '"]').removeClass('in-deck');
        $('#deck-building .card[data-id="' + cardId + '"]').remove();
    }

    $('#deck-building .card').each(function () {
        $(this).addClass('in-deck');
        var dataId = $(this).data('id');
        $('#collection .card[data-id="' + dataId + '"]').addClass('in-deck');
    });

    $('#deck-building, #collection').on('click', '.card-actions .deck', handleDeckActionClick);
    $('#deck-building-container')
        .on('contextmenu', '.card, .card-actions, .card-actions .cta', function (e) {
            e.preventDefault();
        })
        .on('dragstart', '.card-actions .cta', function (e) {
            e.preventDefault();
        });

    const MARKET_SEEN_COOKIE = 'market_seen_events';
    const MARKET_SEEN_OUTBID_COOKIE = 'market_seen_outbid_events';
    const MARKET_SEEN_MAX_AGE = 30 * 24 * 60 * 60;

    function readCookie(name) {
        const escaped = name.replace(/[-.*+?^${}()|[\]\\]/g, '\\$&');
        const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    function writeCookie(name, value, maxAgeSeconds) {
        let cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
        if (maxAgeSeconds) {
            cookie += `; max-age=${maxAgeSeconds}`;
        }
        document.cookie = cookie;
    }

    function parseMarketSeenCookie() {
        const raw = readCookie(MARKET_SEEN_COOKIE);
        if (!raw) {
            return {};
        }
        let parsed = null;
        try {
            parsed = JSON.parse(raw);
        } catch (err) {
            return {};
        }
        if (!parsed || typeof parsed !== 'object') {
            return {};
        }
        const seen = (parsed.seen && typeof parsed.seen === 'object') ? parsed.seen : parsed;
        const cleaned = {};
        for (const key in seen) {
            if (!Object.prototype.hasOwnProperty.call(seen, key)) {
                continue;
            }
            const id = parseInt(key, 10);
            const status = seen[key];
            if (!Number.isFinite(id)) {
                continue;
            }
            if (status !== 'winning' && status !== 'outbid') {
                continue;
            }
            cleaned[id] = status;
        }
        return cleaned;
    }

    function saveMarketSeenCookie(seenMap) {
        const payload = { v: 1, seen: seenMap };
        writeCookie(MARKET_SEEN_COOKIE, JSON.stringify(payload), MARKET_SEEN_MAX_AGE);
    }

    function parseMarketSeenOutbidCookie() {
        const raw = readCookie(MARKET_SEEN_OUTBID_COOKIE);
        if (!raw) {
            return {};
        }
        let parsed = null;
        try {
            parsed = JSON.parse(raw);
        } catch (err) {
            return {};
        }
        if (!parsed || typeof parsed !== 'object') {
            return {};
        }
        const seen = (parsed.seen && typeof parsed.seen === 'object') ? parsed.seen : parsed;
        const cleaned = {};
        for (const key in seen) {
            if (!Object.prototype.hasOwnProperty.call(seen, key)) {
                continue;
            }
            const id = parseInt(key, 10);
            if (!Number.isFinite(id)) {
                continue;
            }
            cleaned[id] = true;
        }
        return cleaned;
    }

    function saveMarketSeenOutbidCookie(seenMap) {
        const payload = { v: 1, seen: seenMap };
        writeCookie(MARKET_SEEN_OUTBID_COOKIE, JSON.stringify(payload), MARKET_SEEN_MAX_AGE);
    }

    function markMarketAlertsSeen() {
        if (!$('body').hasClass('template-market')) {
            return;
        }
        const $items = $('.market-alerts__item[data-market-event-id][data-market-event-status]');
        if (!$items.length) {
            return;
        }
        const seenMap = parseMarketSeenCookie();
        const outbidSeenMap = parseMarketSeenOutbidCookie();
        let changed = false;
        let outbidChanged = false;

        $items.each(function () {
            const $item = $(this);
            const id = parseInt($item.data('market-event-id'), 10);
            const status = $item.data('market-event-status');
            if (!Number.isFinite(id)) {
                return;
            }
            if (status === 'winning' || status === 'outbid') {
                if (seenMap[id] !== status) {
                    seenMap[id] = status;
                    changed = true;
                }
                return;
            }
            if (status === 'outbid_event' || status === 'listing_outbid_event') {
                if (!outbidSeenMap[id]) {
                    outbidSeenMap[id] = true;
                    outbidChanged = true;
                }
            }
        });

        if (changed) {
            saveMarketSeenCookie(seenMap);
        }
        if (outbidChanged) {
            saveMarketSeenOutbidCookie(outbidSeenMap);
        }

        const $counter = $('.market-counter');
        if ($counter.length) {
            $counter.text('0').hide();
        }
    }

    markMarketAlertsSeen();

    $('#collection').on('click', '.card-actions .auction', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('[Market] Confirm listing requested');
        if (!window.confirm(t('js.market.confirm_listing'))) {
            return;
        }
        const $card = $(this).closest('.card');
        const cardId = $card.data('id');
        if (!cardId) {
            return;
        }
        const $form = $('<form>', {
            method: 'post',
            action: '/market'
        });
        $form.append($('<input>', { type: 'hidden', name: 'action', value: 'create_auction' }));
        $form.append($('<input>', { type: 'hidden', name: 'card_id', value: cardId }));
        $('body').append($form);
        $form.trigger('submit');
    });
    $(document).on('submit', '.auction-bid-form', function (e) {
        const action = $(this).find('input[name="action"]').val();
        if (action !== 'bid') {
            return;
        }
        if (!window.confirm(t('js.market.confirm_bid'))) {
            e.preventDefault();
        }
    });
    $('#deck-building').on('click', '.card-actions .zoom', function (e) {
        e.preventDefault();
        const $card = $(this).closest('.card');
        showCardInLightbox($card);
    });
    $('.card-actions').on('click', '.zoom', function (e) {
        if (window.collectionApp && $(this).closest('#collection-container').length) {
            return;
        }
        e.preventDefault();
        const $card = $(this).closest('.card');
        showCardInLightbox($card);
    });

    $(document).on('click', '.card', function (event) {
        if (isDeckDragActive) {
            return;
        }

        if (Date.now() < suppressDeckCardClickUntil && $(this).closest('#deck-building').length) {
            return;
        }

        if ($(this).hasClass('zoomed')) {
            return; // Ne rien faire si carte zoomée
        }

        const $card = $(this);
        const $actionTarget = $(event.target).closest('.card-actions .cta');
        const wasActive = $card.hasClass('active');
        if (DEBUG_DECK_ACTIONS) {
            console.log('[DeckDebug] Card click', {
                cardId: $card.data('id'),
                eventTarget: event.target,
                wasActive,
                hasActionTarget: $actionTarget.length > 0
            });
        }

        // Toujours garder une seule carte active à la fois
        $('.card').not(this).removeClass('active');

        if ($actionTarget.length) {
            // Si l'utilisateur clique sur un bouton (zoom/add), on laisse la carte active
            $card.addClass('active');
        } else {
            // Sinon on bascule simplement l'état actif de la carte
            $card.toggleClass('active');
        }

    });

    // Initialiser le texte du bouton 'deck' pour chaque carte
    function updateDeckButtonText() {
        $('#collection .collection-cards .card').each(function () {
            if ($(this).hasClass('in-deck')) {
                $(this).find('.deck').text(t('js.deck.remove'));
            } else {
                $(this).find('.deck').text(t('js.deck.add'));
            }
        });
        $('#deck-building .collection-cards .card').each(function () {
            $(this).find('.deck').text(t('js.deck.remove'));
        });

        updateAddToDeckButtons(); // Ensure buttons are correctly shown or hidden
        updateDeckProgress();
    }


    function updateAddToDeckButtons() {
        const canAddMoreCards = $('#deck-building').find('.card').length < 6;
        $('#collection .collection-cards .card:not(.in-deck)').find('.deck')
            .show()
            .toggleClass('is-disabled', !canAddMoreCards)
            .attr('aria-disabled', canAddMoreCards ? 'false' : 'true')
            .text(canAddMoreCards ? t('js.deck.add') : t('js.deck.full'));
    }

    function setOnboardingStepLink($step, href) {
        const $existingLink = $step.children('.onboarding-journey__step-link');

        if (!href) {
            if ($existingLink.length) {
                $existingLink.contents().appendTo($step);
                $existingLink.remove();
            }
            return;
        }

        if ($existingLink.length) {
            $existingLink.attr('href', href);
            return;
        }

        const $content = $step.contents();
        $('<a class="onboarding-journey__step-link"></a>')
            .attr('href', href)
            .append($content)
            .appendTo($step);
    }

    function updateOnboardingJourneyDeckStep(count, max) {
        const $journey = $('.onboarding-journey');
        if (!$journey.length) {
            return;
        }

        const $step2 = $journey.find('.onboarding-journey__step[data-step="2"]');
        const $step3 = $journey.find('.onboarding-journey__step[data-step="3"]');
        const $cta = $journey.find('.onboarding-journey__cta');
        if (!$step2.length || !$step3.length) {
            return;
        }

        const isReady = count >= max;
        const collectionTarget = $journey.attr('data-collection-target') || '/collection?clear_filters=1';
        const battleTarget = $journey.attr('data-battle-target') || '/play';
        const deckLabelTemplate = $journey.attr('data-deck-label-template') || '';
        const deckLabel = deckLabelTemplate
            .replace('__COUNT__', count)
            .replace('__MAX__', max);

        if (deckLabel) {
            $step2.find('.onboarding-journey__text').text(deckLabel);
        }

        $step2
            .toggleClass('is-complete', isReady)
            .toggleClass('is-current', !isReady);
        $step3
            .removeClass('is-complete')
            .toggleClass('is-current', isReady);

        setOnboardingStepLink($step2, isReady ? null : collectionTarget);
        setOnboardingStepLink($step3, isReady ? battleTarget : null);

        if ($cta.length) {
            $cta
                .attr('href', isReady ? battleTarget : collectionTarget)
                .text(isReady
                    ? ($journey.attr('data-cta-start-battle') || $cta.text())
                    : ($journey.attr('data-cta-complete-deck') || $cta.text()));
        }

        $('header nav a').removeClass('is-onboarding-next');
        $('header nav a.' + (isReady ? 'battle' : 'cards-deck')).addClass('is-onboarding-next');
        syncHeaderHeightVar();
    }

    function updateDeckProgress() {
        const $progress = $('#deck-progress');
        const $quickBattle = $('#collection-quick-battle');
        if (!$progress.length && !$quickBattle.length) {
            return;
        }

        const count = $('#deck-building .collection-cards .card').length;
        const max = parseInt($progress.data('max'), 10) || 6;
        const isReady = count >= max;
        const labelTemplate = $progress.data('label-template') || t('js.deck.count', { count: '{count}', max: '{max}' });
        const readyLabel = $progress.data('ready-label') || t('js.deck.ready');

        if ($progress.length) {
            $progress
                .data('count', count)
                .toggleClass('is-ready', isReady)
                .text(isReady ? readyLabel : labelTemplate.replace('__COUNT__', count).replace('__MAX__', max));
        }

        if ($quickBattle.length) {
            $quickBattle
                .toggleClass('is-disabled', !isReady)
                .attr('aria-disabled', isReady ? 'false' : 'true')
                .attr('title', isReady ? '' : t('js.deck.complete_first'));
        }

        updateOnboardingJourneyDeckStep(count, max);
    }

    window.updateDeckProgress = updateDeckProgress;
    updateDeckButtonText();

    // Réordonner les cartes dans le deck via drag-and-drop
    if ($('#deck-building .collection-cards').length) {

        const deckContainer = document.querySelector('#deck-building .collection-cards');
        const hasMatchMedia = typeof window.matchMedia === 'function';
        const hasFinePointer = hasMatchMedia && window.matchMedia('(any-pointer: fine)').matches;
        const hasCoarsePointer = hasMatchMedia && window.matchMedia('(any-pointer: coarse)').matches;
        // Enable touch drag mode only when no fine pointer is available.
        const useTouchDragMode = hasCoarsePointer && !hasFinePointer;
        let lockedScrollY = 0;

        const lockScrollWhileDragging = function () {
            if (!useTouchDragMode || document.body.classList.contains('deck-drag-scroll-lock')) {
                return;
            }

            lockedScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
            document.body.style.top = `-${lockedScrollY}px`;
            document.body.classList.add('deck-drag-scroll-lock');
        };

        const unlockScrollAfterDragging = function () {
            if (!document.body.classList.contains('deck-drag-scroll-lock')) {
                return;
            }

            document.body.classList.remove('deck-drag-scroll-lock');
            document.body.style.top = '';
            window.scrollTo(0, lockedScrollY);
            lockedScrollY = 0;
        };

        const preventTouchScrollDuringDrag = function (event) {
            if (document.body.classList.contains('deck-drag-scroll-lock')) {
                event.preventDefault();
            }
        };

        deckContainer.addEventListener('touchmove', preventTouchScrollDuringDrag, { passive: false });

        Sortable.create(deckContainer, {
            animation: 140,
            delay: useTouchDragMode ? TOUCH_DECK_DRAG_DELAY_MS : 0,
            delayOnTouchOnly: true,
            touchStartThreshold: 6,
            fallbackTolerance: 8,
            forceFallback: useTouchDragMode,
            fallbackOnBody: useTouchDragMode,
            filter: function (event) {
                const originalEvent = event || {};
                const eventTarget = originalEvent.target;
                const actionTarget = eventTarget && eventTarget.closest
                    ? eventTarget.closest('.card-actions .cta')
                    : null;
                return !!(actionTarget && deckContainer.contains(actionTarget));
            },
            preventOnFilter: false,
            onStart: function () {
                resetAllCardTilts(true);
                isDeckDragActive = true;
                deckContainer.classList.add('deck-dragging');
                lockScrollWhileDragging();
            },
            onEnd: function () {
                isDeckDragActive = false;
                suppressDeckCardClickUntil = Date.now() + 300;
                deckContainer.classList.remove('deck-dragging');
                unlockScrollAfterDragging();
                console.log('Card positions updated.');
                $(document).trigger('collection:sort-end');
                const updateRequest = sendDeckUpdate();
                if (updateRequest && typeof updateRequest.catch === 'function') {
                    updateRequest.catch(function (error) {
                        if (
                            window.collectionApp
                            && typeof window.collectionApp.showDeckStatus === 'function'
                        ) {
                            window.collectionApp.showDeckStatus(
                                error && error.message ? error.message : t('js.common.error_generic')
                            );
                        }
                        console.error('Unable to save reordered deck:', error);
                    });
                }
            }
        });

        window.addEventListener('touchend', function () {
            if (!isDeckDragActive) {
                return;
            }

            isDeckDragActive = false;
            deckContainer.classList.remove('deck-dragging');
            unlockScrollAfterDragging();
        }, { passive: true });
    }

    let deckUpdateRequest = null;
    let deckUpdateQueued = false;
    let lastSentDeckSignature = null;
    const deckUpdateWaiters = [];

    function collectDeckDataSnapshot() {
        const deckCards = $('#deck-building .collection-cards .card');
        const deckData = [];

        deckCards.each(function (index) {
            const cardId = $(this).data('id');
            deckData.push({ id: cardId, position: index });
        });

        return deckData;
    }

    function resolveDeckUpdateWaiters() {
        while (deckUpdateWaiters.length > 0) {
            const waiter = deckUpdateWaiters.shift();
            waiter.resolve({ success: true });
        }
    }

    function issueDeckUpdateRequest() {
        const deckData = collectDeckDataSnapshot();
        const deckId = parseInt($('#deck-list').val(), 10);
        const signature = JSON.stringify({
            deckId: Number.isFinite(deckId) ? deckId : null,
            cards: deckData
        });

        if (signature === lastSentDeckSignature) {
            resolveDeckUpdateWaiters();
            return;
        }

        deckUpdateRequest = $.ajax({
            url: '/ajax/update-deck',
            method: 'POST',
            data: { deck_id: deckId, deck: deckData },
            success: function (response) {
                lastSentDeckSignature = signature;
                console.log('Deck updated successfully:', response);
            },
            error: function (xhr, status, error) {
                console.error('Error updating deck:', error);
            }
        });

        deckUpdateRequest.always(function () {
            deckUpdateRequest = null;
            if (deckUpdateQueued) {
                deckUpdateQueued = false;
                issueDeckUpdateRequest();
                return;
            }
            resolveDeckUpdateWaiters();
        });
    }

    // Mise à jour du deck via AJAX
    function sendDeckUpdate() {
        if (window.collectionApp && typeof window.collectionApp.saveCurrentDeck === 'function') {
            return window.collectionApp.saveCurrentDeck({ immediate: true });
        }

        const waiter = $.Deferred();
        deckUpdateWaiters.push(waiter);

        if (deckUpdateRequest) {
            deckUpdateQueued = true;
            return waiter.promise();
        }

        issueDeckUpdateRequest();
        return waiter.promise();
    }

    $('#collection-quick-battle').on('click', function (event) {
        event.preventDefault();

        const $button = $(this);
        if ($button.hasClass('is-disabled') || $button.attr('aria-disabled') === 'true') {
            $('#deck-building-container').addClass('needs-attention');
            setTimeout(() => $('#deck-building-container').removeClass('needs-attention'), 900);
            return;
        }

        if ($button.data('navigating')) {
            return;
        }

        $button.data('navigating', true);

        const targetUrl = $button.attr('href') || '/play';
        const loadingLabel = $button.data('loading-label') || t('js.common.loading');
        setLinkLoadingState($button, true, loadingLabel);

        const request = sendDeckUpdate();
        if (!request) {
            window.location.href = targetUrl;
            return;
        }

        if (typeof request.always === 'function') {
            request.always(function () {
                window.location.href = targetUrl;
            });
            return;
        }

        Promise.resolve(request)
            .then(function () {
                window.location.href = targetUrl;
            })
            .catch(function (error) {
                $button.data('navigating', false);
                setLinkLoadingState($button, false);
                console.error('Unable to save the deck before battle:', error);
            });
    });

    // Cacher le bouton de suppression de deck s'il n'y a qu'un seul deck
    if ($('#deck-list option').length <= 1) {
        $('#delete-deck').hide();
    }

    // Gestion du changement de deck
    $('#deck-list').on('change', function () {
        var selectedDeck = $(this).val();
        if (window.collectionApp && typeof window.collectionApp.switchDeck === 'function') {
            window.collectionApp.switchDeck(parseInt(selectedDeck, 10)).catch(function (error) {
                console.error('Error switching deck:', error);
            });
            return;
        }
        window.location.href = window.location.pathname + '?id_deck=' + selectedDeck;
    });

    // Confirmation de la suppression du deck
    $('#delete-deck').on('click', function () {
        if (confirm(t('js.deck.confirm_delete'))) {
            var selectedDeck = $('#deck-list').val();
            window.location.href = window.location.pathname + '?id_deck_delete=' + selectedDeck;
        }
    });

    // Renommer le deck
    $('#rename-deck').on('click', function () {
        var selectedDeck = $('#deck-list').val();
        var newName = prompt(t('js.deck.rename_prompt'));
        if (newName) {
            window.location.href = window.location.pathname + '?id_deck_rename=' + selectedDeck + '&new_name=' + encodeURIComponent(newName);
        }
    });

    // Ajouter un nouveau deck
    $('#add-deck').on('click', function () {
        var newDeckName = prompt(t('js.deck.add_prompt'));
        if (newDeckName) {
            window.location.href = '/collection?add_deck=' + encodeURIComponent(newDeckName);
        }
    });

    // Edit username
    $('#edit-username').on('click', function () {
        var newName = prompt(t('js.user.rename_prompt'));
        if (newName) {
            window.location.href = window.location.pathname + '?new_name=' + encodeURIComponent(newName);
        }
    });

    // GA4: booster_open when opening a new booster
    $('#open-booster-action form button[type="submit"]').on('click', function(){
        if (window.gtag) { gtag('event', 'booster_open'); }
    });

    // Referral
    $('#referral-link, #copy-referral-link').on('click', function () {
        var referralValue = $('#referral-link').val();
        if (!referralValue) {
            return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(referralValue)
                .then(() => {
                    alert(t('js.clipboard.copied'));
                })
                .catch(err => {
                    console.error('Clipboard error:', err);
                    alert(t('js.common.error_generic'));
                });
        } else {
            alert(t('js.clipboard.copy_manual', { value: referralValue }));
        }
        if (window.gtag) { gtag('event', 'referral_click'); }
    });
    // Referral share links
    $(document).on('click', '.share-referral a, .account-share-links a', function(){
        if (window.gtag) { gtag('event', 'referral_click'); }
    });

    function persistAccountPreferenceCookie(name, value) {
        var cookieName = name === 'battle_sound_enabled' ? 'battle_sound_enabled_v2' : name;
        var maxAge = 365 * 24 * 60 * 60;
        var hostname = (window.location.hostname || '').toLowerCase();
        var isVoidScourgeHost = /(^|\.)void-scourge\.com$/.test(hostname);
        var cookie = encodeURIComponent(cookieName) + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';

        if (isVoidScourgeHost) {
            cookie += '; domain=.void-scourge.com; Secure';
        } else if (window.location.protocol === 'https:') {
            cookie += '; Secure';
        }

        document.cookie = cookie;

        try {
            window.localStorage.setItem(cookieName, value);
        } catch (err) {}
    }

    // Account preferences
    $('#account-preferences-form input:checked').each(function () {
        var $input = $(this);
        var name = $input.attr('name');

        if (name) {
            persistAccountPreferenceCookie(name, $input.val());
        }
    });

    $('#account-preferences-form input').on('change', function () {
        var $form = $('#account-preferences-form');
        var $input = $(this);
        var name = $input.attr('name');
        var value = $input.val();

        if (name) {
            persistAccountPreferenceCookie(name, value);
        }

        $.post($form.attr('action'), $form.serialize())
            .fail(function (xhr, status, error) {
                console.error('Failed to save account preferences:', status, error);
            });
    });

    function closeHeaderEventSelector() {
        $('header .event-selector').removeClass('is-open');
        $('header .current-event__trigger').attr('aria-expanded', 'false');
        $('body').removeClass('event-selector-open');
    }

    $(document).on('click', 'header .current-event__trigger', function (e) {
        e.stopPropagation();
        var $selector = $(this).siblings('.event-selector');
        var shouldOpen = !$selector.hasClass('is-open');

        closeHeaderEventSelector();

        if (shouldOpen) {
            $selector.addClass('is-open');
            $(this).attr('aria-expanded', 'true');
            $('body').addClass('event-selector-open');
        }
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('header .event-selector').length) {
            return;
        }

        closeHeaderEventSelector();
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            closeHeaderEventSelector();
        }
    });

    // Toggle deck display on ranking page
    $('.toggle-deck').on('click', function (e) {
        e.preventDefault();
        var targetSelector = $(this).data('target');
        var $targetRow = $(targetSelector);
        $targetRow.toggle();
        refreshCircles();
    });

    // Open achievement deck in lightbox when clicking the whole block
    $(document).on('click', '.top1-illustration[data-target]', function (e) {
        e.preventDefault();
        var targetSelector = $(this).data('target');
        var $src = $(targetSelector);
        if ($src.length) {
            var html = '<div class="lightbox-inner">' + $src.prop('outerHTML') + '</div>';
            // Ensure inner is visible in lightbox
            html = html.replace('style="display:none;','style="display:flex;');
            handleLightbox(html);
            refreshCircles();
        }
    });

    // GA4: draft_join when user switches to a draft event
    $(document).on('click', '.event-selector a.draft', function() {
        if (window.gtag) { gtag('event', 'draft_join'); }
    });

    // GA4: referral_click when arriving with ?referral
    try {
        var hasReferral = new URLSearchParams(window.location.search).has('referral');
        if (hasReferral && window.gtag) { gtag('event', 'referral_click'); }
    } catch(e) {}

    // (FTUE auto-flow removed)

    // ----- PWA install prompt after 2 matches (mobile) -----
    (function(){
        var deferredPrompt = null;
        window.addEventListener('beforeinstallprompt', function(e){
            e.preventDefault();
            deferredPrompt = e;
        });
        window.addEventListener('appinstalled', function(){
            try {
                localStorage.setItem('pwa_installed', '1');
            } catch(e) {}
            if (window.gtag) { gtag('event', 'pwa_install'); }
        });

        function maybePromptPWA(){
            try {
                var installed = localStorage.getItem('pwa_installed') === '1';
                var prompted = localStorage.getItem('pwa_prompted') === '1';
                var matches = parseInt(localStorage.getItem('matches_played') || '0', 10) || 0;
                var isMobile = typeof window.isMobileDevice === 'function' && window.isMobileDevice();
                if (!installed && !prompted && isMobile && matches >= 2 && deferredPrompt) {
                    // simple confirm-based prompt to avoid adding UI
                    if (confirm('Install Void Scourge for quicker access?')) {
                        deferredPrompt.prompt();
                        deferredPrompt.userChoice.finally(function(){
                            deferredPrompt = null;
                        });
                    }
                    localStorage.setItem('pwa_prompted', '1');
                }
            } catch(e) {}
        }

        // Check on load and after a short delay
        setTimeout(maybePromptPWA, 800);
        document.addEventListener('visibilitychange', function(){ if (!document.hidden) maybePromptPWA(); });
    })();

    // ----- Share deck: copy short URL -----
    $(document).on('click', '#share-deck-btn', function(){
        var url = $(this).data('url');
        if (!url) url = window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url)
              .then(function(){ alert(t('js.clipboard.copied')); })
              .catch(function(){ alert(t('js.clipboard.copy_manual', { value: url })); });
        } else {
            alert(t('js.clipboard.copy_manual', { value: url }));
        }
    });

    function getPendingDraftRewards() {
        if (!Array.isArray(window.DRAFT_REWARDS) || !window.DRAFT_REWARDS.length) {
            return [];
        }

        let store = null;
        try {
            store = window.sessionStorage;
        } catch (e) {
            store = null;
        }

        return window.DRAFT_REWARDS.filter(function (reward) {
            if (!reward || typeof reward.event_id === 'undefined') {
                return false;
            }
            if (!store) {
                return true;
            }

            try {
                return !store.getItem('draftRewardNotified_' + reward.event_id);
            } catch (e) {
                return true;
            }
        });
    }

    function markDraftRewardsNotified(rewards) {
        if (!rewards || !rewards.length) {
            return;
        }

        let store = null;
        try {
            store = window.sessionStorage;
        } catch (e) {
            store = null;
        }

        if (!store) {
            return;
        }

        rewards.forEach(function (reward) {
            if (!reward || typeof reward.event_id === 'undefined') {
                return;
            }

            try {
                store.setItem('draftRewardNotified_' + reward.event_id, '1');
            } catch (e) {
                /* ignore quota errors */
            }
        });
    }

    (function showDraftRewardPopup() {
        const pendingRewards = getPendingDraftRewards();
        if (!pendingRewards.length) {
            return;
        }

        const tpl = document.getElementById('draft-reward-popup-template');
        if (!tpl) {
            return;
        }

        markDraftRewardsNotified(pendingRewards);
        handleLightbox(tpl.innerHTML);
    })();

    (function showBonusVotePopup() {
        const tpl = document.getElementById('bonus-vote-popup-template');
        if (!tpl) {
            return;
        }

        const openPopup = function () {
            handleLightbox(tpl.innerHTML);
        };

        window.setTimeout(function () {
            const $activeLightbox = $('.lightbox.active');
            if ($activeLightbox.length) {
                $(document).one('lightboxClosed.bonusVotePopup', openPopup);
                return;
            }

            openPopup();
        }, 350);
    })();

    $(document).on('click', '.js-close-draft-reward, .js-close-lightbox', function (e) {
        e.preventDefault();
        const $lightbox = $('.lightbox');
        if ($lightbox.length === 0) {
            return;
        }

        $lightbox.fadeOut(300, function () {
            $lightbox.removeClass('active');
            $(document).trigger('lightboxClosed');
        });
    });

    $(document).on('click', '.bonus-vote-popup__cta', function () {
        const $lightbox = $('.lightbox');
        if ($lightbox.length === 0) {
            return;
        }

        $lightbox.fadeOut(150, function () {
            $lightbox.removeClass('active');
            $(document).trigger('lightboxClosed');
        });
    });

    // Register service worker for PWA (if available)
    if ('serviceWorker' in navigator && window.isSecureContext) {
        try {
            navigator.serviceWorker.register('/service-worker.js')
                .catch(() => { /* swallow registration errors (e.g., invalid local cert) */ });
        } catch(e) { /* ignore */ }
    }

});


function handleLightbox(contentHtml) {
    let $lightbox = $('.lightbox');

    if ($lightbox.length === 0) {
        $lightbox = $('<div class="lightbox"></div>');
        $('body').append($lightbox);
    }

    // Injecter le contenu dans la lightbox (supporte HTML string, élément DOM ou jQuery)
    if (typeof window.destroyCircleTypesIn === 'function') {
        window.destroyCircleTypesIn($lightbox);
    }
    $lightbox.empty();
    if (contentHtml instanceof jQuery) {
        $lightbox.append(contentHtml);
    } else if (contentHtml instanceof Element) {
        $lightbox.append($(contentHtml));
    } else {
        $lightbox.html(contentHtml);
    }
    $lightbox.addClass('active').hide().fadeIn(300, function () {
        applyCircleType($lightbox);
    });

    rebindTooltips($lightbox);
    applyCircleType($lightbox);

    // Gestion de la fermeture de la lightbox
    $lightbox.off('click').on('click', function (e) {
        // Ferme uniquement si on clique en dehors du contenu
        if ($(e.target).is('.lightbox')) {
            $lightbox.fadeOut(300, function () {
                $lightbox.removeClass('active');
                $(document).trigger('lightboxClosed');
            });
        }
    });
}
